<template>
  <v-container>
    <div class="list mb-2 mb-sm-10 mx-0 mx-sm-n8" style="padding-left:16px">
      <div v-for="(item, i) in list" :key="i" @click="gotoOrder(item)" class="card mb-5 mb-sm-10"
        style="display:inline-block;margin-left:20px">
        <v-img class="white--text img align-end mx-2 mx-sm-9" :src="item.image" eager contain>
        </v-img>
        <div class="mx-2 mt-2 mb-3 mx-sm-4 mt-sm-5 mb-sm-7">
          <v-card-subtitle class="px-0 py-0">
            <span class="title-txt">{{ $t("coin") }} {{ item.price && item.price.hourprice | coinF }}</span>
            <span class="gray text-decoration-line-through ml-2" v-if="item.price && item.price.hourprice_origin != '0'">
              {{$t("coin") }} {{ item.price && item.price.hourprice_origin | coinF }}
            </span>
          </v-card-subtitle>
          <v-card-subtitle class="px-0 py-0">
              <v-row no-gutters align="center" class="desc-1 pt-1 pt-sm-4">
                <v-icon color="darken-2" size="20px" class="mr-1">
                  mdi-account
                </v-icon>
                <span class="mr-1 mr-sm-5 text-caption text-sm-body-1">{{ item.seats }}</span>
                <template v-if="item.automatic == '1'">
                  <v-icon color="darken-2" size="20px" class="mr-1">
                    mdi-wrench
                  </v-icon>
                  <span class=" text-caption text-sm-body-1">{{ $t("automatic") }}</span>
                </template>
                <template v-else>
                  <v-icon color="darken-2" size="20px" class="mr-1">
                    mdi-wrench
                  </v-icon>
                  <span class=" text-caption text-sm-body-1">{{ $t("noautomatic") }}</span>
                </template>
              </v-row>
            </v-card-subtitle>
            <v-card-subtitle class="px-0 py-0">
              <div class="desc pt-5">{{ item.brand.brand_name }}/{{ item.carmodel.model_num }}</div>
            </v-card-subtitle>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'CarList',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data: () => ({}),
  filters: {
    coinF(number) {
      let numStr = number.toString();
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  methods: {
    gotoOrder(item) {
      this.$router.push({ path: '/cardetail', query: { goods_id: item.id } });
    }
  },
}
</script>
<style scoped lang="scss">
.list {
  @media screen and (max-width:600px) {
    .list>div {
      width: 50%;
    }

    .card {

      margin-top: 30px;
      position: relative;
      width: 150px !important;
      height: 200px !important;
      background: #FFFFFF;
      box-shadow: 0px 15px 40px 0px rgba(0, 0, 0, 0.04);
      border-radius: 5px;
      overflow: hidden;
      border-color: transparent;
      margin: auto;

      .card-top {
        margin: 0 -4px;
      }

      .title-txt {
        height: 15px !important;
        font-family: Roboto, Roboto;
        font-weight: 500 !important;
        font-size: 12px !important;
        color: #1B1B1B;
        line-height: 15px !important;
        text-align: left;
        font-style: normal;
      }

      .text-decoration-line-through {
        font-size: 12px !important;
      }

      .desc {
        height: 12px !important;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 10px !important;
        color: #8E8E93;
        line-height: 12px !important;
        text-align: left;
        font-style: normal;
      }

      .bottom {
        position: absolute;
        bottom: 0;
        width: 80%;
      }

      .price {
        height: 14px !important;
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 12px !important;
        color: #1B1B1B;
        line-height: 14px !important;
        text-align: center;
        font-style: normal;
      }

      .huaxian {
        height: 14px !important;
        font-family: Roboto, Roboto;
        font-size: 12px !important;
        line-height: 14px !important;
      }
    }

    .img {
      height: 100px !important;
    }
  }

  .img {
    height: 218px;
  }

  .card {
    position: relative;
    max-width: 316px;
    background: #FFFFFF;
    box-shadow: 0px 18px 49px 0px rgba(0, 0, 0, 0.04);
    border-radius: 10px;

    .sale {
      position: absolute;
      left: 22px;
      top: 22px;
      width: 62px;
      height: 35px;
      background: #FFFFFF;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 15px;
      color: #E42129;
      line-height: 21px;
      letter-spacing: 1px;
      text-align: left;
      font-style: normal;
    }

    .title-txt {
      height: 41px;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 29px;
      color: #3B3A40;
      line-height: 44px;
      text-align: left;
      font-style: normal;
    }

    .desc {
      height: 32px;
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 19px;
      color: #64626A;
      line-height: 32px;
      text-align: left;
      font-style: normal;
    }

    .desc-1 {
      height: 21px;
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 18px;
      color: #64626A;
      line-height: 21px;
      text-align: left;
      font-style: normal;
    }
  }
}
</style>